export default __webpack_public_path__ + "static/media/logo-item-3.ddcc379d.jpeg";